<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="350px" persistent>
      <v-card :loading="!fetched">
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("windowReceiptsAdditional.title") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="mt-5 d-flex flex-column">
          <kkm-select class="ma-2" @setNumDevice="(num)=>kkmNumDevice=num"></kkm-select>
          <v-btn elevation="0" class="ma-2" @click="openShift">
            {{ $t("windowReceiptsAdditional.open_shift") }}
          </v-btn>
          <v-btn elevation="0" class="ma-2" @click="closeShift">
            {{ $t("windowReceiptsAdditional.close_shift") }}
          </v-btn>
          <v-btn elevation="0" class="ma-2" @click="xReport">
            {{ $t("windowReceiptsAdditional.x_report") }}
          </v-btn>
          <v-btn elevation="0" class="ma-2" @click="zReport">
            {{ $t("windowReceiptsAdditional.z_report") }}
          </v-btn>
          <v-btn elevation="0" class="ma-2" @click="isVisibleCorrectionReceiptWindow = true">
            {{ $t("windowReceiptsAdditional.correction_receipt") }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isVisibleCorrectionReceiptWindow"
      scrollable
      max-width="850px"
      persistent
    >
      <v-card>
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t("windowReceiptsAdditional.correction_receipt") }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="isVisibleCorrectionReceiptWindow = false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="mt-1">
          <v-form ref="correctionReceiptForm">
            <v-radio-group
              v-model="correctionReceiptOptions.receiptType"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
            >
              <h3 class="mb-2">
                {{ $t("windowReceiptsAdditional.correction_receipt_type") }}
              </h3>
              <v-radio
                v-for="correctionReceiptType in correctionReceiptTypes"
                :key="correctionReceiptType.type"
                :label="correctionReceiptType.name"
                :value="correctionReceiptType.type"
              ></v-radio>
            </v-radio-group>
            <v-radio-group
              v-model="correctionReceiptOptions.CorrectionType"
              :rules="[
                (v) => (!!v || v===0) || $t('form.validationErrors.field_is_required'),
              ]"
            >
              <h3 class="mb-2">
                {{
                  $t(
                    "windowReceiptsAdditional.correction_receipt_correction_type"
                  )
                }}
              </h3>
              <v-radio
                v-for="correctionReceiptCorrectionType in correctionReceiptCorrectionTypes"
                :key="correctionReceiptCorrectionType.type"
                :label="correctionReceiptCorrectionType.name"
                :value="correctionReceiptCorrectionType.type"
              ></v-radio>
            </v-radio-group>
            <h3>
              {{
                $t("windowReceiptsAdditional.date_of_document_for_correction")
              }}
            </h3>
            <date-time-picker
              :not-round="true"
              class="mt-2 d-block mb-3"
              outlined
              :date-label="$t('common.date')"
              :time-label="$t('common.time')"
              :date.sync="correctionReceiptOptions.date"
              :time.sync="correctionReceiptOptions.time"
              :min-date="undefined"
              :min-time="undefined"
            />

            <!--          CorrectionBaseDate;-->
            <v-text-field
              outlined
              v-if="fetched || !!this.$route.params.id"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              v-model="correctionReceiptOptions.CorrectionBaseNumber"
              :label="
                $t('windowReceiptsAdditional.number_document_for_correction')
              "
              hide-details
            ></v-text-field>
            <v-text-field
              outlined
              class="mt-3"
              v-if="fetched || !!this.$route.params.id"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
              ]"
              v-model="correctionReceiptOptions.CorrectionBaseName"
              :label="
                $t('windowReceiptsAdditional.name_document_for_correction')
              "
              hide-details
            ></v-text-field>
            <v-text-field
              outlined
              class="mt-3"
              v-if="fetched || !!this.$route.params.id"
              :rules="[
                (v) => !!v || $t('form.validationErrors.field_is_required'),
                (v) => (v && v.replace(/,/g, '.')==parseFloat(v.replace(/,/g, '.'))) || $t('form.validationErrors.must_be_float'),
              ]"
              v-model="correctionReceiptOptions.correctionSum"
              :label="
                $t('common.total_sum')
              "
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="savingInProgress || !fetched"
            :loading="savingInProgress"
            class="mt-2 mr-4"
            color="warning"
            elevation="0"
            @click="printCorrectionReceipt"
            @keyup.enter="printCorrectionReceipt"
          >
            {{ $t("windowReceiptsAdditional.print_correction_receipt") }}
          </v-btn>
          <v-btn
            :disabled="savingInProgress || !fetched"
            class="mt-2 white--text"
            elevation="0"
            color="red"
            @click="isVisibleCorrectionReceiptWindow = false"
            @keyup.enter="isVisibleCorrectionReceiptWindow = false"
          >
            {{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import DateTimePicker from "@/components/common/DateTimePicker";
import {
  KKMPrintReceipt,
  KKMOpenShift,
  KKMCloseShift,
  KKMReportReceipt
} from "@/plugins/kkm-server-api";
import KkmSelect from "./KkmSelect";

export default {
  name: "ReceiptsAdditionalWindow",
  components: {KkmSelect, DateTimePicker },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      kkmNumDevice: -1,
      savingInProgress: false,
      correctionReceiptOptions: {},
      isVisibleCorrectionReceiptWindow: false,

      correctionReceiptCorrectionTypes: [
        //Тип коррекции
        {
          type: 0,
          name: "самостоятельно",
        },
        {
          type: 1,
          name: "по предписанию",
        },
      ],
      correctionReceiptTypes: [
        //Тип чека коррекции
        {
          type: 2,
          name: "корректировка продажи/прихода",
        },
        {
          type: 3,
          name: "корректировка возврата продажи/прихода",
        },
        {
          type: 12,
          name: "корректировка покупки/расхода",
        },
        {
          type: 13,
          name: "корректировка возврата покупки/расхода; (>=ФФД 1.1)",
        },
      ],
    };
  },
  methods:{
    xReport(){
      this.printReportReceipt('x')
    },
    zReport(){
      this.printReportReceipt('z')
    },
    closeShift(){
      this.printShiftReceipt('close');
    },
    openShift(){
      this.printShiftReceipt('open');
    },
    printReportReceipt(type){
      let options = {
        // ИНН ККМ для поиска. Если "" то ККМ ищется только по NumDevice,
        // Если NumDevice = 0 а InnKkm заполнено то ККМ ищется только по InnKkm
        InnKkm: "",
        // Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
        TaxVariant: "",
        // Номер устройства. Если 0 то первое не блокированное на сервере
        // Не рекомендовано для использования.
        // Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
        NumDevice: this.kkmNumDevice,
        // Уникальный идентификатор команды. Любая строка из 40 символов - должна быть уникальна для каждой подаваемой команды
        // По этому идентификатору можно запросить результат выполнения команды
        // Поле не обязательно
      };

      KKMReportReceipt(type, options,  ()=>{}, (error)=>{
        this.$error(error)
      })
    },
    printShiftReceipt(type){
      let options = {
        InnKkm: "",
        // Система налогообложения (СНО) для поиска ККТ, Можно не указывать, или = "" - любое СНО
        TaxVariant: "",
        // Номер устройства. Если 0 то первое не блокированное на сервере
        // Не рекомендовано для использования.
        // Рекомендуем для поиска ККТ задавать InnKkm и TaxVariant !!!!!!
        NumDevice: this.kkmNumDevice,
        // Id устройства. Строка. Если = "" то первое не блокированное на сервере
        IdDevice: "",
        // Продавец, тег ОФД 1021
        CashierName: this.authenticatedUser.name,
        // ИНН продавца тег ОФД 1203
        CashierVATIN: this.authenticatedUser.inn,
      }
      switch (type){
        case 'open':
          KKMOpenShift(options, ()=>{}, (error)=>{
            this.$error(error)
            //console.log(error)
          });
          break;
        case 'close':
          KKMCloseShift(options, ()=>{}, (error)=>{
            this.$error(error)
            //console.log(error)
          });
          break;
      }
    },
    printCorrectionReceipt(){
      if(this.$refs['correctionReceiptForm'].validate()){
        if(!this.correctionReceiptOptions.date || !this.correctionReceiptOptions.time){
          this.$error(this.$t('windowReceiptsAdditional.choose_datetime'))
        } else{
          this.correctionReceiptOptions.CorrectionBaseDate = this.correctionReceiptOptions.date+'T'+this.correctionReceiptOptions.time;
          //this.correctionReceiptOptions.date = null;
          //this.correctionReceiptOptions.time = null;
          this.correctionReceiptOptions.correctionSum = parseFloat(this.correctionReceiptOptions.correctionSum).toFixed(2);

          let options = {
            //номер устройства
            numDevice: this.kkmNumDevice,
            //название компании
            companyName: this.shop.legal_name,
            //имя кассира
            cashierName: this.authenticatedUser.name,
            // ИНН продавца Тег ОФД 1203
            cashierINN: this.authenticatedUser.inn, //"430601071197",

            // Тип чека, Тег 1054;
            // 0 – продажа/приход;                      10 – покупка/расход;
            // 1 – возврат продажи/прихода;             11 - возврат покупки/расхода;
            // 2 – корректировка продажи/прихода;       12 – корректировка покупки/расхода;
            receiptType: this.correctionReceiptOptions.receiptType,

            // ИНН ККМ для поиска. Если "" то перове не блокированное на сервере
            InnKkm: this.receipts_settings.inn ? this.receipts_settings.inn : '',
            authorizationCode: null,
            RRNCode: null,
            // НДС в процентах или ТЕГ НДС: 0 (НДС 0%), 10 (НДС 10%), 20 (НДС 20%), -1 (НДС не облагается), 120 (НДС 20 /120), 110 (НДС 10 /110), Тег 1043, Из нее расчет тега 1079
            tax: this.receipts_settings.nds,
          };
          let mergedOptions = {...options, ...this.correctionReceiptOptions};
          mergedOptions.receiptNumber = new Date().getTime();

          KKMPrintReceipt(
              [

              ],
              mergedOptions,
              (res) => {
                //успешно распечатанный чек
              },
              (error) => {
                this.$store.dispatch("common/showError", { error });
              }
          );


        }
      }
    },
  },
  computed: {
    shop() {
      return this.authenticatedUser.shop;
    },
    ...mapFields("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapFields("receipts_settings", ["receipts_settings", "fetched"]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
      },
    },
  },
  watch: {
    isVisibleCorrectionReceiptWindow() {
      this.correctionReceiptOptions = {};
      if(this.$refs['correctionReceiptForm'])this.$refs['correctionReceiptForm'].reset()
    },
  },
};
</script>

<style scoped></style>
